/**
 * @file common.ts
 * @author Rapoo Device SDK Team
 * @date 2026-01-29
 * @description CH585M系列设备通用方法
 */
import { ProtocolConfig } from '../../../types/protocol'
import { CMD_CH585M, PROTOCOL_CONFIG } from '../protocols/cmd'
import { createCheckACK, createSendRead, createSendWrite } from '../../../utils/common'

const protocolConfig: ProtocolConfig = {
  reportId: PROTOCOL_CONFIG.report_id,
  featureReportId: PROTOCOL_CONFIG.feature_report_id,
  busy_ack_value: PROTOCOL_CONFIG.busy_ack_value,
  read_ack_value: PROTOCOL_CONFIG.read_ack_value,
  readCmd: CMD_CH585M.read_eeprom,
  writeCmd: CMD_CH585M.write_eeprom,
}
export const checkACK = createCheckACK(protocolConfig)
export const sendRead = createSendRead(protocolConfig)
export const sendWrite = createSendWrite(protocolConfig)

export const versionFileName = 'version.json'
/** 兼容旧引用：保留常量导出（默认国内 URL）。新代码请使用 `device.getFirmwareBaseUrl()`。 */
export const upgradeBaseUrl = 'https://soft.rapoo.com/RapooDriver/Firmware'
